// extracted by mini-css-extract-plugin
module.exports = {"guide":"Paper_guide__3wIn8","intro":"Paper_intro__6QjPP","intro_1":"Paper_intro_1___7V2K"};